<template>
  <div>
    <!-- PRERESA -->
    <div
      class="columns is-gapless is-marginless"
      v-if="membre && forPreResa">
      <div
        class="column is-narrow is-flex is-padding-small tooltip is-tooltip-right is-border-right"
        :style="isCheck ? '' : 'background-color: #FAFBFD'"
        :class="isCheck ? 'has-background-success' : ''"
        :data-tooltip="isCheck ? 'Fiche complète' : 'Fiche incomplète'">
        <span
          class="icon has-text-white is-self-centered"
          :class="isCheck ? 'has-text-white' : textFalse">
          <i
            :class="isCheck ? 'fa-check-circle' : 'fa-exclamation-circle'"
            class="fas"
            style="font-size: 1.8rem"
            :style="isCheck ? '' : 'color: #ff0000'"></i>
        </span>
      </div>
      <div class="is-padding-xsmall">
        <div class="is-flex is-nowrap is-vcentered is-margin-bottom-xxsmall">
          <div
            :style="isCheck ? 'background-color: #F2F7F0' : 'background-color: #FFE2E2'"
            class="column has-text-primary is-size-7 is-padding-xsmall info-profil">
            <div
              style="min-width: auto; "
              class="is-flex is-nowrap">
              <span class="has-text-black">Les informations attendues pour la réservation  {{ isCheck ? 'sont correctement renseignées.' : 'ne sont pas correctement renseignées.' }}</span>
            </div>
            <div
              style="width: 100%">
              <div style="width: 100%">
                <!-- Nouvelle modale contact preResa -->
                <a
                  @click="$emit('updateContact', membre, index)"
                  class="is-flex-between is-nowrap">
                  <div>
                    <span class="is-underline has-text-weight-bold">{{ isCheck ? 'Vérifier l\'ensemble des données de l\'acquéreur.' : 'Complétez les données du contact.' }}</span>
                  </div>
                  <i class="fas fa-arrow-right"></i>
                </a>
                <!-- <div
                  v-else
                  style="width: 100%">
                  <router-link
                    style="width: 100%"
                    :to="{name: 'ContactEdit', params: {id: membre.pk}, query: {check: true}}">
                    <div class="is-flex-between is-nowrap">
                      <span class="is-underline has-text-weight-bold">{{ isCheck ? 'Vérifier l\'ensemble des données de l\'acquéreur.' : 'Complétez les données du contact.' }}</span>
                      <i class="fas fa-arrow-right"></i>
                    </div>
                  </router-link>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div
          class="is-flex is-nowrap"
          style="width: 100%; justify-content: space-between">
          <div
            style="display: flex; flex-direction: column; width: 80%"
            class="is-marginless">
            <div class="is-flex is-gapless is-padding-top-small is-padding-bottom-xxsmall is-padding-right-xxsmall">
              <div>
                <r-label
                  v-if="isMembrePromoteur"
                  :label="'RÉSERVANT / PROMOTEUR'"
                  :is-required="false"></r-label>
                <r-label
                  v-else-if="isCoAcquereur"
                  :label="'RÉSERVATAIRE / CO-Acquéreur'"
                  :is-required="false"></r-label>
                <r-label
                  v-else
                  :label="'RÉSERVATAIRE / Acquéreur'"
                  :is-required="false"></r-label>

                <div class="title is-5 has-text-weight-medium has-text-weight-bold">
                  <div
                    v-if="isMembrePromoteur"
                    class="title is-5 has-text-weight-medium">
                    <div class="is-uppercase">
                      {{ membre.company_name || 'NC' }}
                    </div>
                    <div
                      class="is-uppercase"
                      v-if="membre.rep_first_name && membre.rep_last_name">
                      {{ membre.rep_last_name }} <span style="is-uppercase">{{ membre.rep_first_name }}</span>
                    </div>
                  </div>
                  <div
                    v-else
                    class="title is-5 has-text-weight-medium has-text-weight-bold">
                    <div
                      class="is-uppercase"
                      v-if="'nature' in membre && membre.nature && membre.nature === 'corporation'">
                      {{ membre.corporation_name }}
                    </div>
                    <div
                      class="is-uppercase"
                      v-if="membre.first_name && membre.last_name">
                      {{ membre.last_name }} <span class="is-uppercase">{{ membre.first_name }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <r-label
                  :label="'Adresse'"
                  :is-required="false"></r-label>
                <div
                  class="title is-5 has-text-weight-medium is-uppercase has-text-weight-bold"
                  v-if="membre && membre.address">
                  <div>
                    <span
                      v-if="membre.address.line1"
                      class="is-break-word">{{ membre.address.line1 }}</span>&nbsp;
                    <span v-if="membre.address.zip_code || membre.address.city">{{ membre.address.zip_code }} {{ membre.address.city }}</span>&nbsp;
                    <span v-if="membre.address.country">{{ membre.address.country }}</span>
                    <span
                      v-if="!membre.address.line1 && !membre.address.zip_code &&
                        !membre.address.country && !membre.address.city">
                      NC
                    </span>
                  </div>
                </div>
                <div
                  class="title is-5 has-text-weight-medium is-uppercase has-text-weight-bold"
                  v-else-if="membre && membre.rep_address">
                  <span v-if="membre.rep_address.line1">{{ membre.rep_address.line1 }}</span>
                  <span v-if="membre.rep_address.zip_code || membre.rep_address.city">{{ membre.rep_address.zip_code }} {{ membre.rep_address.city }}</span>&nbsp;
                  <span v-if="membre.rep_address.country">{{ membre.rep_address.country }}</span>
                  <span
                    v-if="!membre.rep_address.line1 && !membre.rep_address.zip_code &&
                      !membre.rep_address.country && !membre.rep_address.city">
                    NC
                  </span>
                </div>
                <span
                  class="has-text-weight-bold"
                  v-else>
                  NC
                </span>
              </div>
            </div>
            <div class="is-flex is-gapless is-padding-top-xxsmall is-padding-bottom-xxsmall is-padding-right-xxsmall">
              <div>
                <r-label
                  :label="'Téléphone'"
                  :is-required="false"></r-label>
                <div class="title is-5 has-text-weight-medium has-text-weight-bold">
                  <phone-number
                    v-if="'phone' in membre && membre.phone"
                    :phone="membre.phone"></phone-number>
                  <phone-number
                    v-else-if="'rep_phone' in membre && membre.rep_phone"
                    :phone="membre.rep_phone"></phone-number>
                  <span v-else>
                    NC
                  </span>
                </div>
              </div>
              <div>
                <r-label
                  :label="'Email'"
                  :is-required="false"></r-label>
                <div class="title is-5 has-text-weight-medium has-text-weight-bold">
                  <span>{{ membre.email || membre.rep_email || 'NC' }}</span>
                </div>
              </div>
            </div>
            <br>
            <div
              class="is-flex is-wrap-flex is-margin-bottom-xxsmall"
              style="gap: 5px">
              <div
                v-for="document in filteredDocuments"
                :key="document.fus_id">
                <div
                  v-if="document && document.destination && document.destination.includes('reservation')"
                  class="is-padding-top-xxsmall is-padding-bottom-xxsmall is-padding-right-xsmall is-padding-left-xsmall is-size-6"
                  style="width: fit-content; border-radius: 15px; border: solid 1px #707070;">
                  {{ document.filename }}
                  &nbsp;
                  <a @click="deleteDocument(document)">
                    <i class="fal fa-trash-alt"></i>
                  </a>
                </div>
              </div>
              <a
                @click="$emit('updateContact', membre, index)"
                class="is-padding-top-xxsmall is-padding-bottom-xxsmall is-padding-right-xsmall is-padding-left-xsmall is-size-6"
                style="width: fit-content; border-radius: 15px; border: solid 1px #707070;">
                {{ "Ajouter une pièce jointe" }}
                &nbsp;
                <i class="far fa-link"></i>
              </a>
            </div>
          </div>
          <div
            v-if="!isMembrePromoteur && isCoAcquereur && canEdit"
            class="">
            <button
              @click="deleteCobuyer(membre)"
              style="height: 100%; border: none; background-color: #f6f8fa; cursor: pointer"
              class="is-padding-xsmall"
              data-tooltip="Supprimer le co-acquéreur">
              <span class="icon"><i class="fal fa-trash-alt"></i></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isNil, isEmpty } from 'lodash'
import { isValidPhoneNumber } from 'libphonenumber-js'
export default {
  name: 'MembrePreResa',
  props: {
    index: Number,
    membre: Object,
    isMembrePromoteur: Boolean,
    isCoAcquereur: Boolean,
    isGrey: {
      type: Boolean,
      default: false
    },
    fromResa: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean
    },
    forPreResa: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /**
       * is check
       * @returns {boolean}
       */
    isCheck () {
      const phone = this.membre.phone || this.membre.rep_phone
      const phoneValid = !phone || isValidPhoneNumber(phone)
      if (this.isMembrePromoteur) {
        return !isNil(this.membre.rep_last_name) &&
            !isNil(this.membre.company_name) &&
            !isNil(this.membre.rep_first_name) &&
            !isEmpty(this.membre.rep_address) &&
            !isNil(this.membre.rep_phone) &&
            !isNil(this.membre.rep_email) &&
            phoneValid
      } else {
        return this.membre.is_complete && phoneValid
      }
    },
    /**
       * background class
       * @returns {string}
       */
    bgFalse () {
      if (this.isGrey) {
        return 'has-background-white--darken1'
      } else {
        return 'has-background-danger'
      }
    },
    /**
       * text class
       * @returns {string}
       */
    textFalse () {
      if (this.isGrey) {
        return 'has-text-danger'
      } else {
        return 'has-text-white'
      }
    },
    filteredDocuments () {
      return this.membre.documents.filter(document => document.destination && document.destination.includes('reservation'))
    }
  },
  methods: {
    deleteCobuyer (membre) {
      this.$emit('deleteCobuyer', membre)
    },
    deleteDocument (document) {
      this.$emit('deleteDocument', document)
    }
  }
}
</script>

<style scoped>
.info-profil {
  display: flex;
  flex-flow: row nowrap;
  gap: 5px;
  width: 100%
}

@media (min-width: 1200px) and (max-width: 1410px) {
  .info-profil {
    flex-wrap: wrap;
  }
}
</style>
